import React, { useState } from "react";
import { TiTick } from "react-icons/ti";
import WebBannerSvgImg from "../../assets/images/web-application-compatible-on-multiple-devcies.webp";
import WebApplicationImg from "../../assets/images/efficient-web-app-with-role-based-access.avif";
import "../../App.css";
import CustomTabs from "../../components/CustomTabs";
import CustomBanner from "../../components/CustomBanner";
import FAQSection from "../../components/FAQSection";
import SwiperComponent from "../../components/SwiperComponent";
import { techStacks } from "./TabsTechStacks";

import { Link } from "react-router-dom";
import { routes } from "../../config/utilities/utils.constant";
import { faqData, process } from "./WebAppsData";
import { motion } from "framer-motion";
import { Head } from "vite-react-ssg";

const WebApps = () => {
  return (
    <>
      <Head>
        <title>Building feature-rich web apps with dynamic data feeds</title>
        <meta
          name="description"
          content="Develop innovative and highly-customized web solutions with endless customization options, interactive animations and robust databases."
        />
        <link
          rel="canonical"
          href="https://apptalyst.com/web-applications"
        />
      </Head>
      <CustomBanner
        svgImg={WebBannerSvgImg}
        svgWidth="w-[12rem] mobSmallScreen:w-[14rem] mobMediumScreen:w-[18rem] screen-400:w-[20rem]  xs:w-[20rem]   sm:w-[21rem] md:w-[23rem]  lg:w-[26rem] xl:w-[30rem] "
        svgPosition="-bottom-[5rem] mobMediumScreen:-bottom-[6rem]  screen-400:-bottom-[7rem]  xs:-bottom-[7rem] sm:-bottom-[7rem] md:top-[60%]  lg:top-[55%]  xl:top-[49%] "
        imgAlt="A user viewing the same web application on desktop, laptop and mobile phone as they’re designed for all these devices."
      >
        <div className="md:w-10/12">
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px] leading-[1] font-bold "
          >
            Web Application Development
          </motion.h1>
        </div> 

        <ul className="space-y-2">
          <li className="flex items-start  md:items-center  text-base md:text-lg">
            <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-0">
              <TiTick />
            </span>
            Highly customizable websites.
          </li>
          <li className="flex items-start  md:items-center  text-base md:text-lg">
            <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-0">
              <TiTick />
            </span>
            Stunning animations and design sense.
          </li>
          <li className="flex items-start  md:items-center  text-base md:text-lg">
            <span className="text-dark mr-2 bg-[#FFC067] rounded-full p-0.5 mt-0.5 md:mt-0">
              <TiTick />
            </span>
            Advanced functionality for complex workflows.
          </li>
        </ul>
      </CustomBanner>
      <div className="container space-y-20 md:space-y-32 mb-20 md:mb-32">
        <div className="flex flex-col lg:flex-row space-y-10 lg:space-y-0   lg:space-x-8 sm:px-10   lg:px-0">
          <div className="space-y-10 w-full lg:w-7/12 ">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
              className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] 2xl:text-[50px] font-bold text-center md:text-start text-dark font-butler"
            >
              Why choose web applications
            </motion.h2>

            <ul className="space-y-2 text-lg">
              <li className="flex items-start  space-x-2 text-dark">
                <span className="text-dark  bg-[#FFC067] rounded-full p-0.5 mt-1 text-base md:text-lg">
                  <TiTick />
                </span>

                <p className="text-base leading-[1.625rem]">
                  Robust databases and web portals designed to achieve infinite
                  possibilities for incorporating desired features.
                </p>
              </li>
              <li className="flex items-start  space-x-2 text-dark">
                <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-1 text-base md:text-lg">
                  <TiTick />
                </span>

                <p className="text-base leading-[1.625rem]">
                  Microservices architecture enables independently deployable
                  components built for seamless growth.
                </p>
              </li>
              <li className="flex items-start  space-x-2 text-dark">
                <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-1 text-base md:text-lg">
                  <TiTick />
                </span>

                <p className="text-base leading-[1.625rem]">
                  {" "}
                  Modern tech stacks for blazing-fast performance and SEO
                  optimization.
                </p>
              </li>
            </ul>
          </div>
          <div className="w-full lg:w-5/12 ">
            <img
              // loading="lazy"
              src={WebApplicationImg}
              alt="Admin dashboard of a web app opened on a laptop and user-subscription screen opened on a tablet."
              className="rounded w-full h-full"
            />
          </div>
        </div>
        <CustomTabs techStacks={techStacks} />
        <SwiperComponent process={process} />
        <FAQSection faqData={faqData} />
      </div>
    </>
  );
};

export default WebApps;
